import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

export default function useDeleteShopView(shopId: string, viewId: string) {
	return useApiMutation<"delete", "/shops/{shopId}/views/{viewId}", void>("delete", "/shops/{shopId}/views/{viewId}", {
		invalidate: useInvalidateShop(shopId),
		mapVariables: () => ({
			params: { path: { viewId, shopId } },
		}),
	});
}
